export default __webpack_public_path__ + "/assets/avvisi-01.png";